import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import SkillItem from './SkillItem';

const useStyles = makeStyles({
    skillSection: {
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#e8f1f5',
        textAlign: 'center',
    },
    skillHeader: {
        paddingBottom: '30px',
    },
    skillBody: {
        '& .col-lg-1_5': {
            "@media (min-width: 992px)": {
                flex: '0 0 auto',
                width: '20%',
            },
        }
    },
})

function Skills() {

    const classes = useStyles()

    return (
        <div className={classes.skillSection}>
            <div className="container">
                <div className={classes.skillHeader}>
                    <h1>What will you learn</h1>
                    <p>Skills you will be learning through this program</p>
                </div>
                <div className={classes.skillBody}>
                    <div className="row">
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Problem Identification" image="/pitchbattle/images/icons/problem-solving.png" color="color1" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Customer Discovery" image="/pitchbattle/images/icons/design-thinking.png" color="color2" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Market Research" image="/pitchbattle/images/icons/resilience.png" color="color3" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Pitching and Storytelling" image="/pitchbattle/images/icons/introduction.png" color="color4" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Value Proposition Development" image="/pitchbattle/images/icons/skill-quotient.png" color="color5" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Business Model Development" image="/pitchbattle/images/icons/leader.png" color="color6" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Prototyping and Validation" image="/pitchbattle/images/icons/team-work.png" color="color7" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Emotional Intelligence" image="/pitchbattle/images/icons/emotionally-stable.png" color="color8" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Negotiation" image="/pitchbattle/images/icons/pitching.png" color="color9" />
                        </div>
                        <div className="col-lg-1_5 col-6">
                            <SkillItem name="Networking" image="/pitchbattle/images/icons/people.png" color="color10" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills
